@if (batch() && batchDeparture()) {
  <div class="batch-view-wrapper">
    @if (batch().status === BatchStatusEnum.UNCOMMITED) {
      <section class="checkbox">
        <input
          type="checkbox"
          [id]="'selected_card' + batchDeparture().number"
          [ngModel]="batchDeparture().selected"
          (ngModelChange)="changeSelected($event)"
        />

        <label [for]="'selected_card' + batchDeparture().number">
          <div class="checkbox__el"></div>
        </label>
      </section>
    }

    <article
      class="batch-view-card pointer"
      [ngStyle]="{
        width: batch().status === BatchStatusEnum.COMMITED ? '100%' : '',
      }"
      (click)="redirectToBatchDepartureCard()"
    >
      @if (batch().status === BatchStatusEnum.COMMITED) {
        <section class="batch-view-card__status-block">
          @switch (batchDeparture()?.tracking_code?.main_status) {
            @case (batchMailingStatus.NO_DATA) {
              <span class="status status__no-data">
                {{ 'NO_DATA' | translate }}
              </span>
            }
            @case (batchMailingStatus.AWARDED) {
              <span class="status status__handed">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.HANDED'
                    | translate
                }}
              </span>
            }
            @case (batchMailingStatus.REJECTED) {
              <span class="status status__rejected">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.REFUND'
                    | translate
                }}
              </span>
            }
            @case (batchMailingStatus.ON_THE_ROAD) {
              <span class="status status__on-the-road">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.ON_THE_WAY'
                    | translate
                }}
              </span>
            }
            @case (batchMailingStatus.REDIRECTED) {
              <span class="status status__redirected">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.REDIRECTED'
                    | translate
                }}
              </span>
            }
            @case (batchMailingStatus.PICKUP) {
              <span class="status status__pickup">
                {{
                  'BATCH_MAILING.BATCHES_TAB.DEPARTURE_STATUS.TO_BE_ISSUED'
                    | translate
                }}
              </span>
            }
          }
        </section>
      }

      @if (
        !batchDeparture().partial_receipts_count && batch().is_partial_receipt
      ) {
        <section class="batch-view-card__status-block">
          <span class="status status__rejected">
            {{
              'BATCH_MAILING.BATCHES_TAB.DEPARTURE_CARD.NO_ATTACHMENTS'
                | translate
            }}
          </span>
        </section>
      }

      <section class="batch-view-card-sections">
        <div class="batch-view-card-sections-item">
          <span class="batch-view-card-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.NUMBER'
                | translate
                | uppercase
            }}
          </span>

          <span class="batch-view-card-item-value">
            {{ batchDeparture().number }}
          </span>
        </div>

        <div class="batch-view-card-sections-item">
          <span class="batch-view-card-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.S10CODE'
                | translate
                | uppercase
            }}
          </span>

          <span class="batch-view-card-item-value">
            {{ batchDeparture().s10code ? batchDeparture().s10code : '-' }}
          </span>
        </div>

        <div class="batch-view-card-sections-item">
          <span class="batch-view-card-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.WEIGHT'
                | translate
                | uppercase
            }}
          </span>

          <span class="batch-view-card-item-value">
            {{ batchDeparture().weight || '-' }}
          </span>
        </div>

        <div class="batch-view-card-sections-item">
          <span class="batch-view-card-item-title">
            {{
              'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.COST' | translate | uppercase
            }}
          </span>

          <span class="batch-view-card-item-value">
            {{ batchDeparture().cost }}
          </span>
        </div>

        @if (batch().is_partial_receipt) {
          <div class="batch-view-card-sections-item">
            <span class="batch-view-card-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.ATTACHMENTS'
                  | translate
                  | uppercase
              }}
            </span>

            <span class="batch-view-card-item-value">
              {{ batchDeparture().partial_receipts_count }}
            </span>
          </div>
        }

        <div
          class="item-wrapper"
          [ngStyle]="{ width: (isFullScreen$ | async) ? '400px' : '300px' }"
        >
          <div
            class="batch-view-card-sections-item"
            [ngStyle]="{
              'max-width': (isFullScreen$ | async) ? '320px' : '220px',
            }"
          >
            <span class="batch-view-card-item-title">
              {{
                'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.RECIPIENT_NAME'
                  | translate
                  | uppercase
              }}
            </span>

            @if (batchDeparture()?.recipient_contact_widget_data) {
              <span
                class="batch-view-card-item-value"
                [tooltip]="
                  isCompanyNameLong
                    ? isCompanyNameLong
                    : showRecipientName(batchDeparture())
                "
              >
                {{ showRecipientName(batchDeparture()) }}
              </span>
            }
          </div>

          @if (batch().status === BatchStatusEnum.UNCOMMITED) {
            <section class="pointer batch-view-card__btns-block">
              <button
                type="button"
                stopPropagation
                class="filter-button action-button"
                (click)="navigateToEditDeparturePage()"
              >
                <fa-icon
                  class="filter-button-icon"
                  [icon]="faPenToSquare"
                ></fa-icon>
              </button>

              <button
                type="button"
                stopPropagation
                class="filter-button red action-button"
                (click)="deleteDeparture.emit(batchDeparture().id)"
              >
                <fa-icon class="filter-button-icon red" [icon]="faTrashAlt">
                </fa-icon>
              </button>
            </section>
          }
        </div>
      </section>

      <section class="batch-view-card-sections-address-item">
        <span class="batch-view-card-item-title">
          {{
            'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.RECIPIENT_FULL_ADDRESS'
              | translate
              | uppercase
          }}
        </span>

        <span class="address-item-value">
          {{
            batchDeparture()?.recipient_contact_widget_data?.address
              ?.full_address || '-'
          }}
        </span>
      </section>

      @if (
        batchDeparture().issued_partial_receipts_count ||
        batchDeparture().canceled_partial_receipts_count
      ) {
        <section class="batch-view-card__refund-status-block">
          @if (batchDeparture().issued_partial_receipts_count) {
            <div class="batch-view-card__refund-status-block-issued-item">
              <fa-icon
                [ngStyle]="{ color: '#1C951A' }"
                [icon]="faCircleCheck"
              ></fa-icon>

              <span>
                {{
                  'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.RECEIVED_ATTACHMENTS'
                    | translate
                }}: {{ batchDeparture().issued_partial_receipts_count }}
              </span>
            </div>
          }

          @if (batchDeparture().canceled_partial_receipts_count) {
            <div class="batch-view-card__refund-status-block-canceled-item">
              <fa-icon
                [ngStyle]="{ color: '#ed0000' }"
                [icon]="faCircleXmark"
              ></fa-icon>

              <span>
                {{
                  'BATCH_MAILING.BATCHES_TAB.VIEW_CARD.RETURNED_ATTACHMENTS'
                    | translate
                }}: {{ batchDeparture().canceled_partial_receipts_count }}
              </span>
            </div>
          }
        </section>
      }

      @if (batchDeparture().has_documents_label) {
        <section class="batch-view-card__blanks-block">
          <div class="batch-view-card__blanks-btns-block">
            <button
              type="button"
              stopPropagation
              [disabled]="isDownloadLabelDisabled()"
              class="button button--outlined button--xs d-flex align-items-center"
              (click)="downloadDepartureLabel()"
            >
              @if (
                loadingLabelRequestState() === BatchDocumentStatus.PROCESSING
              ) {
                <div class="spinner text-center mr-2">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="sr-only">{{ 'LOADING' | translate }}</span>
                  </div>
                </div>
              }
              {{ 'ADDRESSED_LABEL' | translate }}
            </button>

            @if (isDownloadPartialReceiptAvailable()) {
              <button
                type="button"
                stopPropagation
                [disabled]="isDownloadPartialReceiptDisabled()"
                class="button button--outlined button--xs d-flex align-items-center"
                (click)="downloadDeparturePartialReceipt()"
              >
                @if (
                  loadingPartialReceiptRequestState() ===
                  BatchDocumentStatus.PROCESSING
                ) {
                  <div class="spinner text-center mr-2">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">{{ 'LOADING' | translate }}</span>
                    </div>
                  </div>
                }
                {{ 'DELIVERY.ATTACHMENT_INVENTORY' | translate }}
              </button>
            }
          </div>

          @switch (lastErroredDownloadDocumentType()) {
            @case ('shipping_label') {
              <span class="download-error">{{
                'BATCH_MAILING.BATCHES_TAB.LABEL_FORM_ERROR' | translate
              }}</span>
            }
            @case ('partial_receipts') {
              <span class="download-error">{{
                'BATCH_MAILING.BATCHES_TAB.PARTIAL_RECEIPT_FORM_ERROR'
                  | translate
              }}</span>
            }
          }
        </section>
      }
    </article>
  </div>
}
